/**
 * @module FE-CU16_かけつけ依頼画面
 */
import Header from '../../components/header/Header.vue';
import BreadCrumbList from '../../components/breadCrumb/List.vue';
import PcPageTitle from '@/components/pcPageTitle/PcPageTitle.vue';
import Contact from '../../components/contact/Contact.vue';
import MobileFooter from '../../components/footer/MobileFooter.vue';
import CONSTANTS from '../../constants';

const PAGE_ID = 'FE-CU16';
export default {
  name: 'RustInquiery',
  components: {
    Header,
    BreadCrumbList,
    PcPageTitle,
    Contact,
    MobileFooter,
  },
  data(vm) {
    return {
      isDisabled: true,
      clientNumber: '',
      panelTitle: {
        place: '',
        type: '',
        typeIsBefore: false,
      },
      displayAreaList: [
        {
          id: 1,
          title: vm.$vuetify.lang.t(
            '$vuetify.FECU16かけつけ依頼画面.対象地区詳細カメラ詳細表示領域.利用プラン'
          ),
          text: '',
        },
        {
          id: 2,
          title: vm.$vuetify.lang.t(
            '$vuetify.FECU16かけつけ依頼画面.対象地区詳細カメラ詳細表示領域.お客様番号'
          ),
          text: '',
        },
        {
          id: 3,
          title: vm.$vuetify.lang.t(
            '$vuetify.FECU16かけつけ依頼画面.対象地区詳細カメラ詳細表示領域.警備先名'
          ),
          text: '',
        },
        {
          id: 4,
          title: vm.$vuetify.lang.t(
            '$vuetify.FECU16かけつけ依頼画面.対象地区詳細カメラ詳細表示領域.地区番号'
          ),
          text: '',
        },
        {
          id: 5,
          title: vm.$vuetify.lang.t(
            '$vuetify.FECU16かけつけ依頼画面.対象地区詳細カメラ詳細表示領域.地区名'
          ),
          text: '',
        },
      ],
      planCode: {
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
          '$vuetify.コード.利用プランID.オンライン監視プラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
          '$vuetify.コード.利用プランID.依頼かけつけプラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE]:
          '$vuetify.コード.利用プランID.依頼かけつけプラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN]:
          '$vuetify.コード.利用プランID.セルフ監視プラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE]:
          '$vuetify.コード.利用プランID.セルフ監視プラン',
      },
      planCameraCode: {
        [CONSTANTS.CAMERA_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
          '$vuetify.コード.利用プランID.オンライン監視プラン',
        [CONSTANTS.CAMERA_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
          '$vuetify.コード.利用プランID.カメラ依頼かけつけプラン',
        [CONSTANTS.CAMERA_USAGE_PLAN.SELF_MONITORING_PLAN]:
          '$vuetify.コード.利用プランID.カメラセルフ監視プラン',
      },
      targetPlanCode: [
        CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN,
        CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN,
        CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE,
      ],
      targetCameraCode: [
        CONSTANTS.CAMERA_USAGE_PLAN.ONLINE_MONITORING_PLAN,
        CONSTANTS.CAMERA_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN,
      ],
      redirectFlag: false,
      securityStatus: '',
      warningOccurred: '',
      lockUp: '',
      isAlert: false,
      isLockUp: false,
      displayDistrictUserType: 1,
      notificationCount: 0,
      notificationColor: '',
      notificationImage: require('../../assets/images/icon/notification.png'),
      guardCenterName: '',
      guardCenterPhoneNumber: '',
      displayType: 0,
      usagePlan: 0,
      originalPlan: -1, //#27540
      securityUnitExecutionResults: [],
      CONSTANTS: CONSTANTS,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU16かけつけ依頼画面.かけつけ依頼'),
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU16かけつけ依頼画面.C0001'),
      };
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * APP_CU1601 かけつけ依頼データ取得(表示地区)
     * またはAPP_CU1602 かけつけ依頼データ取得(カメラ)
     * @param {string} param エンドポイント
     * @param {object} queries リクエスト
     * @param {string} method HTTPメソッド
     * @returns {object} レスポンス
     */
    APP_CU1601: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // if (this.displayType == 1) {
            //   apiData = {
            //     contentsInfo: {
            //       displayDistrictInfo: {
            //         usagePlan: 1,
            //         customerNumber: "51-1234567",
            //         securityDestinationName: "警備先1",
            //         districtSplitNumber: "0001",
            //         districtSplitName: "地区名1",
            //         displayDistrictNickname: "自宅",
            //       },
            //       displayDistrictSecurityStatus: {
            //         displayDistrictUserType: 1,
            //         notificationCount: 1234,
            //         serviceTypeList: [
            //           {
            //             serviceType: "N01",
            //           },
            //           {
            //             serviceType: "M02",
            //           },
            //         ],
            //         sendCustomerNumber: "sendCustomerNumber",
            //         securitySendCommandKey: "sendCommandKey",
            //         lockUpSendCommandKey: "lockUpSendCommandKey",
            //       },
            //       contactUsInfo: {
            //         guardCenterName: "ガードセンター名",
            //         guardCenterPhoneNumber: "00-0000-0000",
            //       },
            //     },
            //   };
            // } else if (this.displayType == 2) {
            //   apiData = {
            //     contentsInfo: {
            //       cameraInfo: {
            //         usagePlan: 1,
            //         customerNumber: "51-1234567",
            //         securityDestinationName: "警備先1",
            //         districtSplitName: "地区名1",
            //         districtSplitNumber: "0001",
            //         displyaDistrictNickname: "自宅",
            //         cameraNickName: "リビングカメラ",
            //       },
            //       displayDistrictSecurityStatus: {
            //         sendCustomerNumber: "sendCustomerNumber",
            //         securitySendCommandKey: "sendCommandKey",
            //         lockUpSendCommandKey: "lockUpSendCommandKey",
            //       },
            //       contactUsInfo: {
            //         guardCenterName: "ガードセンター名",
            //         guardCenterPhoneNumber: "00-0000-0000",
            //       },
            //     },
            //   };
            // }
            if (this.displayType == 1) {
              if (
                !this.targetPlanCode.some(
                  (code) => code === apiData.contentsInfo.displayDistrictInfo.usagePlan
                )
              ) {
                this.$router.replace({ path: '/top' });
                this.redirectFlag = true;
              }

              this.panelTitle = {
                place: `- ${apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname} `,
                type: '$vuetify.FECU16かけつけ依頼画面.対象地区',
                typeIsBefore: true,
              };
              this.displayAreaList = [];
              this.displayAreaList.push({
                title: '$vuetify.FECU16かけつけ依頼画面.対象地区詳細カメラ詳細表示領域.利用プラン',
                text: this.planCode[apiData.contentsInfo.displayDistrictInfo.usagePlan],
              });
              this.displayAreaList.push({
                title: '$vuetify.FECU16かけつけ依頼画面.対象地区詳細カメラ詳細表示領域.お客様番号',
                text: apiData.contentsInfo.displayDistrictInfo.customerNumber,
              });
              this.displayAreaList.push({
                title: '$vuetify.FECU16かけつけ依頼画面.対象地区詳細カメラ詳細表示領域.警備先名',
                text: apiData.contentsInfo.displayDistrictInfo.securityDestinationName,
              });
              this.displayAreaList.push({
                title: '$vuetify.FECU16かけつけ依頼画面.対象地区詳細カメラ詳細表示領域.地区番号',
                text:
                  apiData.contentsInfo.displayDistrictInfo.districtSplitNumber === '    '
                    ? '$vuetify.FECU16かけつけ依頼画面.メイン地区'
                    : apiData.contentsInfo.displayDistrictInfo.districtSplitNumber,
              });
              this.displayAreaList.push({
                title: '$vuetify.FECU16かけつけ依頼画面.対象地区詳細カメラ詳細表示領域.地区名',
                text: apiData.contentsInfo.displayDistrictInfo.districtSplitName,
              });

              this.clientNumber = apiData.contentsInfo.displayDistrictInfo.customerNumber;
              this.guardCenterName = apiData.contentsInfo.contactUsInfo.guardCenterName;
              this.guardCenterPhoneNumber =
                apiData.contentsInfo.contactUsInfo.guardCenterPhoneNumber;
              this.displayDistrictUserType =
                apiData.contentsInfo.displayDistrictSecurityStatus.displayDistrictUserType;
              this.notificationCount =
                apiData.contentsInfo.displayDistrictSecurityStatus.notificationCount;
              this.usagePlan = apiData.contentsInfo.displayDistrictInfo.usagePlan;

              let color = 'blue';
              apiData.contentsInfo.displayDistrictSecurityStatus.serviceTypeList.some(function (
                service
              ) {
                let serviceColor =
                  CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE[service.serviceType] ??
                  'blue';
                if (serviceColor === 'red') {
                  color = serviceColor;
                  return true;
                } else if (serviceColor === 'yellow') {
                  color = serviceColor;
                }
              });
              this.notificationColor = color;

              if (apiData.contentsInfo.displayDistrictInfo.usagePlan == 0) {
                this.guardCenterPhoneNumber =
                  apiData.contentsInfo.contactUsInfo.guardCenterPhoneNumber;
              } else {
                this.guardCenterPhoneNumber = '0120-352-413';
              }
            } else if (this.displayType == 2) {
              if (
                !this.targetCameraCode.some(
                  (code) => code === apiData.contentsInfo.cameraInfo.usagePlan
                )
              ) {
                this.$router.replace({ path: '/top' });
              }

              this.panelTitle = {
                place: `- ${apiData.contentsInfo.cameraInfo.cameraNickName} `,
                type: '$vuetify.FECU16かけつけ依頼画面.カメラ',
                typeIsBefore: true,
              };
              this.displayAreaList = [];
              this.displayAreaList.push({
                title: '$vuetify.FECU16かけつけ依頼画面.対象地区詳細カメラ詳細表示領域.利用プラン',
                text: this.planCameraCode[apiData.contentsInfo.cameraInfo.usagePlan],
              });
              this.displayAreaList.push({
                title: '$vuetify.FECU16かけつけ依頼画面.対象地区詳細カメラ詳細表示領域.お客様番号',
                text: apiData.contentsInfo.cameraInfo.customerNumber,
              });
              this.displayAreaList.push({
                title: '$vuetify.FECU16かけつけ依頼画面.対象地区詳細カメラ詳細表示領域.警備先名',
                text: apiData.contentsInfo.cameraInfo.securityDestinationName,
              });
              this.displayAreaList.push({
                title: '$vuetify.FECU16かけつけ依頼画面.対象地区詳細カメラ詳細表示領域.地区番号',
                text:
                  apiData.contentsInfo.cameraInfo.districtSplitNumber === '    '
                    ? '$vuetify.FECU16かけつけ依頼画面.メイン地区'
                    : apiData.contentsInfo.cameraInfo.districtSplitNumber,
              });
              this.displayAreaList.push({
                title: '$vuetify.FECU16かけつけ依頼画面.対象地区詳細カメラ詳細表示領域.地区名',
                text: apiData.contentsInfo.cameraInfo.districtSplitName,
              });
              this.displayAreaList.push({
                title:
                  '$vuetify.FECU16かけつけ依頼画面.対象地区詳細カメラ詳細表示領域.ニックネーム対象地区',
                text: apiData.contentsInfo.cameraInfo.displayDistrictNickname,
              });

              this.clientNumber = apiData.contentsInfo.cameraInfo.customerNumber;
              this.guardCenterName = apiData.contentsInfo.contactUsInfo.guardCenterName;
              this.usagePlan = apiData.contentsInfo.cameraInfo.usagePlan;
              this.originalPlan = apiData.contentsInfo.cameraInfo.originalPlan; // #27540 警備先のもともとの監視プラン

              if (
                apiData.contentsInfo.cameraInfo.usagePlan == 0 ||
                apiData.contentsInfo.cameraInfo.originalPlan === 0 // #27540  警備先のもともとの監視プラン
              ) {
                this.guardCenterPhoneNumber =
                  apiData.contentsInfo.contactUsInfo.guardCenterPhoneNumber;
              } else if (apiData.contentsInfo.cameraInfo.usagePlan == 101) {
                this.guardCenterPhoneNumber = '0120-352-413';
              }
              this.displayDistrictUserType =
                apiData.contentsInfo.displayDistrictSecurityStatus.displayDistrictUserType;
              this.notificationCount =
                apiData.contentsInfo.displayDistrictSecurityStatus.notificationCount;
            }
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      return apiData;
    },
    /**
     * APP_CU9915 警備状態読み出し
     * @param {string} param リクエスト
     */
    APP_CO9915_Security: async function (params) {
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: params,
        })
        .then((response /* eslint-disable-line */) => {
          // サンプルデータ
          // if (this.displayType == 1) {
          //   response = {
          //     contentsInfo: {
          //       securityUnitExecutionResult: 0,
          //       commandExecutionResult: {
          //         app_cu1601: {
          //           forSecurityStatus: {
          //             securityStatus: "N",
          //           },
          //         },
          //       },
          //     },
          //   };
          // } else if (this.displayType == 2) {
          //   response = {
          //     contentsInfo: {
          //       securityUnitExecutionResult: 0,
          //       commandExecutionResult: {
          //         app_cu1602: {
          //           forSecurityStatus: {
          //             securityStatus: "N",
          //           },
          //         },
          //       },
          //     },
          //   };
          // }

          if (
            typeof response.contentsInfo.securityUnitExecutionResult !== 'undefined' &&
            response.contentsInfo.securityUnitExecutionResult == 0
          ) {
            if (this.displayType == 1) {
              switch (
                response.contentsInfo.commandExecutionResult.app_cu1601.forSecurityStatus
                  .securityStatus
              ) {
                case 'N':
                  this.securityStatus =
                    '$vuetify.FECU16かけつけ依頼画面.警備状態データ.外出ALSOK警備中';
                  break;
                case 'M':
                  this.securityStatus =
                    '$vuetify.FECU16かけつけ依頼画面.警備状態データ.在宅ALSOK警備中';
                  break;
                case 'S':
                  this.securityStatus =
                    '$vuetify.FECU16かけつけ依頼画面.警備状態データ.外出セルフ警備中';
                  break;
                case 'L':
                  this.securityStatus =
                    '$vuetify.FECU16かけつけ依頼画面.警備状態データ.在宅セルフ警備中';
                  break;
                case 'F':
                  this.securityStatus = '$vuetify.FECU16かけつけ依頼画面.警備状態データ.警備解除中';
                  break;
                case 'P':
                  this.securityStatus =
                    '$vuetify.FECU16かけつけ依頼画面.警備状態データ.ユーザ点検中';
                  break;
              }
            } else if (this.displayType == 2) {
              switch (
                response.contentsInfo.commandExecutionResult.app_cu1602.forSecurityStatus
                  .securityStatus
              ) {
                case 'N':
                  this.securityStatus =
                    '$vuetify.FECU16かけつけ依頼画面.警備状態データ.外出ALSOK警備中';
                  break;
                case 'M':
                  this.securityStatus =
                    '$vuetify.FECU16かけつけ依頼画面.警備状態データ.在宅ALSOK警備中';
                  break;
                case 'S':
                  this.securityStatus =
                    '$vuetify.FECU16かけつけ依頼画面.警備状態データ.外出セルフ警備中';
                  break;
                case 'L':
                  this.securityStatus =
                    '$vuetify.FECU16かけつけ依頼画面.警備状態データ.在宅セルフ警備中';
                  break;
                case 'F':
                  this.securityStatus = '$vuetify.FECU16かけつけ依頼画面.警備状態データ.警備解除中';
                  break;
                case 'P':
                  this.securityStatus =
                    '$vuetify.FECU16かけつけ依頼画面.警備状態データ.ユーザ点検中';
                  break;
              }
            }
          } else if (
            typeof response.contentsInfo.securityUnitExecutionResult !== 'undefined' &&
            response.contentsInfo.securityUnitExecutionResult != 0
          ) {
            if (response.contentsInfo.securityUnitExecutionResult != -1) {
              this.securityUnitExecutionResults.push(
                response.contentsInfo.securityUnitExecutionResult
              );
            }
            if (!this.$store.getters[`requestApi/getInterruptionFlag`]) {
              this.$store.commit('requestApi/setInterruptionFlag', true);
            }
          } else if (!this.$store.getters[`requestApi/getInterruptionFlag`]) {
            this.$store.commit('requestApi/setInterruptionFlag', true);
          }
        });
    },
    /**
     * APP_CU9915 戸締り確認読み出し
     * @param {string} param リクエスト
     */
    APP_CO9915_LockUp: async function (params) {
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: params,
        })
        .then((response /* eslint-disable-line */) => {
          // サンプルデータ
          // if (this.displayType == 1) {
          //   response = {
          //     contentsInfo: {
          //       securityUnitExecutionResult: 0,
          //       commandExecutionResult: {
          //         app_cu1601: {
          //           forLockUp: {
          //             warningOccurredFlg: true,
          //             lockUpFlg: true,
          //           },
          //         },
          //       },
          //     },
          //   };
          // } else if (this.displayType == 2) {
          //   response = {
          //     contentsInfo: {
          //       securityUnitExecutionResult: 0,
          //       commandExecutionResult: {
          //         app_cu1602: {
          //           forLockUp: {
          //             warningOccurredFlg: true,
          //             lockUpFlg: true,
          //           },
          //         },
          //       },
          //     },
          //   };
          // }

          if (
            typeof response.contentsInfo.securityUnitExecutionResult !== 'undefined' &&
            response.contentsInfo.securityUnitExecutionResult == 0
          ) {
            let warningOccurredFlg = false;
            let lockUpFlag = false;
            if (this.displayType == 1) {
              warningOccurredFlg =
                response.contentsInfo.commandExecutionResult.app_cu1601.forLockUp
                  .warningOccurredFlg;
              lockUpFlag =
                response.contentsInfo.commandExecutionResult.app_cu1601.forLockUp.lockUpFlg;
            } else if (this.displayType == 2) {
              warningOccurredFlg =
                response.contentsInfo.commandExecutionResult.app_cu1602.forLockUp
                  .warningOccurredFlg;
              lockUpFlag =
                response.contentsInfo.commandExecutionResult.app_cu1602.forLockUp.lockUpFlg;
            }
            if (this.displayType == 1 || this.displayType == 2) {
              // 警報発生状態を設定(異常があればtrue)
              this.warningOccurred = warningOccurredFlg
                ? '$vuetify.FECU16かけつけ依頼画面.警報発生データ.あり'
                : '$vuetify.FECU16かけつけ依頼画面.警報発生データ.なし';
              this.isAlert = warningOccurredFlg;
              // 戸締まり状態を設定(異常があればtrue)
              this.lockUp = lockUpFlag
                ? '$vuetify.FECU16かけつけ依頼画面.戸締まりデータ.NG'
                : '$vuetify.FECU16かけつけ依頼画面.戸締まりデータ.OK';
              this.isLockUp = lockUpFlag;
            }
          } else if (
            typeof response.contentsInfo.securityUnitExecutionResult !== 'undefined' &&
            response.contentsInfo.securityUnitExecutionResult != 0
          ) {
            if (response.contentsInfo.securityUnitExecutionResult != -1) {
              this.securityUnitExecutionResults.push(
                response.contentsInfo.securityUnitExecutionResult
              );
            }
            if (!this.$store.getters[`requestApi/getInterruptionFlag`]) {
              this.$store.commit('requestApi/setInterruptionFlag', true);
            }
          } else if (!this.$store.getters[`requestApi/getInterruptionFlag`]) {
            this.$store.commit('requestApi/setInterruptionFlag', true);
          }
        });
    },
    /**
     * 遷移元判定処理
     * @returns ページ遷移元コード
     */
    judgeAncestor: function () {
      switch (this.displayType) {
        case 1:
          return this.CONSTANTS.PAGE_ANCESTOR_CODE.HOME_SECURITY;
        case 2:
          return this.CONSTANTS.PAGE_ANCESTOR_CODE.CAMERA;
        default:
          return null;
      }
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    this.$_pvCount(PAGE_ID);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    this.displayType = 1;
    if (this.$store.state.displayType == 2) {
      this.displayType = this.$store.state.displayType;
    }

    let param = 'post';
    let queries = {};
    if (this.displayType == 1) {
      // 対象地区の場合
      param = '/api/emergencyRequest/emergencyRequestDataDisplayDistrict';
      // param = "post";
      queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
      };
    } else if (this.displayType == 2) {
      // カメラの場合
      param = '/api/emergencyRequest/emergencyRequestDataCamera';
      // param = "post";
      queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        deviceID: this.$store.state.deviceID,
      };
    }

    //以降は、ローディングマークを出して警備ユニットとの通信なので、ここで画面表示
    this.isShowPage = true;

    let method = 'post';
    // APP_CU1601
    let apiData = await this.APP_CU1601(param, queries, method);

    this.$store.commit('requestApi/setInterruptionFlag', false);
    if (
      typeof apiData.contentsInfo !== 'undefined' &&
      this.displayType == 1 &&
      !this.redirectFlag
    ) {
      let promiseList = [];
      this.securityUnitExecutionResults = [];
      // 警備状態送信コマンドキー
      let securityParams = {
        token: queries.token,
        terminalInfo: queries.terminalInfo,
        sendCustomerNumber: apiData.contentsInfo.displayDistrictSecurityStatus.sendCustomerNumber,
        sendCommandKey: apiData.contentsInfo.displayDistrictSecurityStatus.securitySendCommandKey,
        apiId: 10,
        alarmType: 0,
        districtSplitNumber: '',
        securityAreaId: '',
      };
      // APP_CO9915
      promiseList.push(this.APP_CO9915_Security(securityParams));

      // 戸締り確認送信コマンドキー
      let lockUpParams = {
        token: queries.token,
        terminalInfo: queries.terminalInfo,
        sendCustomerNumber: apiData.contentsInfo.displayDistrictSecurityStatus.sendCustomerNumber,
        sendCommandKey: apiData.contentsInfo.displayDistrictSecurityStatus.lockUpSendCommandKey,
        apiId: 10,
        alarmType: 0,
        districtSplitNumber: '',
        securityAreaId: '',
      };
      // APP_CO9915
      promiseList.push(this.APP_CO9915_LockUp(lockUpParams));

      await Promise.all(promiseList);

      if (this.$store.getters[`requestApi/getInterruptionFlag`]) {
        if (this.securityUnitExecutionResults.length != 0) {
          this.$store.commit('requestApi/setInterruptionFlag', false);
          this.$_securityUnitExecutionResultsDialog(this.securityUnitExecutionResults);
        } else {
          this.$store.commit('requestApi/setInterruptionFlag', false);
          this.$_securityUnitExecutionResultDialog(-1);
        }
      }
    }
  },
};
